import { Component, OnInit, Input, OnChanges } from '@angular/core';

@Component({
  selector: 'app-section-certificado',
  templateUrl: './section-certificado.component.html',
  styleUrls: ['./section-certificado.component.css']
})
export class SectionCertificadoComponent implements OnChanges {

  @Input() public objetoSectionCertificado : SectionCertificado = {
    fechaAtencion : null,
    ciudad : '',
    empresa : ''
  }

  constructor() { }

  ngOnChanges() {
    this.getObjetoSectionCertificado();
  }

  private async getObjetoSectionCertificado() {
    try {
      await this.objetoSectionCertificado;
    } catch (exception) {
      console.log(exception);
    }
  }

}

interface SectionCertificado {
  fechaAtencion : Date,
  ciudad : string,
  empresa : string
}